module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.hintMsg,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('pageTitle', {
    attrs: {
      "title": "早餐券详情"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#F5F5F5",
      "min-height": "12.4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "white",
      "padding": "0.2rem 0.35rem",
      "line-height": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.3rem",
      "color": "#333"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.g_breakfastInfo.HotelName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {}
  }, [_vm._v("\n        订单号：" + _vm._s(_vm.g_breakfastInfo.breakfastResvNo) + "\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {}
  }, [_vm._v("\n        创建时间：" + _vm._s(_vm.g_breakfastInfo.createtimeText) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _vm._l((_vm.g_breakfastInfo.AAListBag), function(item, index) {
    return (item.ticketNo != '') ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.LookCode(_vm.g_breakfastInfo.HotelCode, item.ticketNo)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "background-color": "#fff",
        "width": "6.9rem",
        "margin": "0  0.3rem",
        "padding-top": "0.3rem"
      }
    }, [_c('div', {
      staticStyle: {
        "padding-left": "0.4rem",
        "overflow": "hidden"
      }
    }, [(item.statusText == '未使用') ? _c('div', {
      staticStyle: {
        "background-image": "url(../../../static/user/Breakfast/LeftImg_1.png )",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "width": "1.5rem",
        "height": "0.9rem",
        "color": "white",
        "float": "left"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center",
        "line-height": "0.35rem",
        "padding-top": "0.1rem",
        "margin-left": "-0.03rem"
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "0.22rem"
      }
    }, [_vm._v(" 早餐券 ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.03rem"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "0.34rem"
      }
    }, [_vm._v(" ￥" + _vm._s(item.paymoney) + " ")])])]) : _vm._e(), _vm._v(" "), (item.statusText != '未使用') ? _c('div', {
      staticStyle: {
        "background-image": "url(../../../static/user/Breakfast/LeftImg_2.png )",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "width": "1.5rem",
        "height": "0.9rem",
        "color": "white",
        "float": "left"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center",
        "line-height": "0.35rem",
        "padding-top": "0.1rem",
        "margin-left": "-0.03rem"
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "0.22rem"
      }
    }, [_vm._v(" 早餐券 ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.03rem"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "0.34rem"
      }
    }, [_vm._v(" ￥" + _vm._s(item.paymoney) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left",
        "margin-left": "0.2rem",
        "font-size": "0.24rem",
        "line-height": "0.4rem",
        "padding-top": "0.04rem",
        "color": "#666"
      }
    }, [_c('div', {
      staticStyle: {}
    }, [_vm._v(" 有效日期 : " + _vm._s(item.effectiveDate) + " ")]), _vm._v(" "), (item.statusText == '已使用') ? _c('div', {
      staticStyle: {}
    }, [_vm._v(" 使用日期 : " + _vm._s(item.useDate) + " ")]) : _c('div', {
      staticStyle: {
        "padding-top": "0.05rem"
      }
    }, [_vm._v(" 券"), _c('span', {
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v("券码")]), _vm._v("码 : " + _vm._s(item.ticketNo) + " ")])]), _vm._v(" "), (item.statusText == '已过期') ? _c('div', {
      staticStyle: {
        "background-image": "url(../../../static/user/Breakfast/outdate.png )",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "width": "1.9rem",
        "position": "absolute",
        "right": "0.5rem",
        "height": "1.6rem"
      }
    }) : _vm._e(), _vm._v(" "), (item.statusText == '已使用') ? _c('div', {
      staticStyle: {
        "background-image": "url(../../../static/user/Breakfast/used.png )",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "width": "1.9rem",
        "position": "absolute",
        "right": "0.5rem",
        "height": "1.6rem"
      }
    }) : _vm._e(), _vm._v(" "), (item.statusText == '已作废') ? _c('div', {
      staticStyle: {
        "background-image": "url(../../../static/user/Breakfast/invalid.png )",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "width": "1.9rem",
        "position": "absolute",
        "right": "0.5rem",
        "height": "1.6rem",
        "z-index": "1"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#ff9347",
        "font-size": "0.29rem",
        "border-top": "solid 1px #f3f3f3",
        "margin-top": "0.25rem",
        "padding": "0.2rem",
        "text-align": "center"
      }
    }, [_vm._v("\n          查看券码\n        ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.Code2dStr != '') ? _c('div', {
    staticStyle: {
      "position": "fixed"
    },
    attrs: {
      "id": "bg_show"
    },
    on: {
      "click": function($event) {
        return _vm.CleanShadow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Code2dStr != '') ? _c('div', {
    staticClass: "pr container",
    staticStyle: {
      "z-index": "1003",
      "position": "fixed",
      "top": "1.8rem",
      "width": "7.5rem"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0 auto",
      "width": "6rem"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "url( ../../../static/user/Breakfast/2DCode.png )",
      "background-size": "6rem",
      "background-repeat": "no-repeat",
      "height": "6.5rem"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#FEFFFD",
      "font-size": "0.29rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.5rem",
      "min-height": "4.5rem",
      "margin-top": "0.5rem"
    },
    attrs: {
      "src": _vm.Code2dImg
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "0.3rem"
    }
  }, [_vm._v("\n              券码：" + _vm._s(_vm.Code2dStr) + "\n            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.1rem"
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a73c578!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/BreakfastDetails.vue
// module id = 1473
// module chunks = 18